import React, { useState, useEffect } from "react";
import { Wrapper, Container, Card, Div, Text, H2, P, Image } from "./style";
import styled from "styled-components";
import { Overlay } from "../Trending/style";
// import Title from "../Commons/Title";
import { useContext } from "react";
import { ThemeContext } from "../../ThemedContext/Provider";
import { useDispatch, useSelector } from "react-redux";
import { getAllMusic } from "../../redux/music-redux/musicStore";

// const image1 = "./assets/images/rel.png";
// const image2 = "./assets/images/rel2.png";
// const image3 = "./assets/images/rel3.png";
// const image4 = "./assets/images/rel4.png";
// const image5 = "./assets/images/rel5.png";

// const contents = [
//   { image: image1, title: "Jabariya Jodi", article: "Various Artists" },
//   { image: image2, title: "Dilla Ther Jaa", article: "Various Artists" },
//   { image: image3, title: "IK Vaari Aa Jaa Jodi", article: "Various Artists" },
//   { image: image4, title: "Sadda Move Song", article: "Various Artists" },
//   { image: image5, title: "Me Hoon Don", article: "Various Artists" },
//   { image: image5, title: "Me Hoon Don", article: "Various Artists" },
// ];

const NewRelease = ({ subTitle }) => {
  const { theme } = useContext(ThemeContext);
  const [stat, setState] = useState();
  const dispatch = useDispatch();
  const musics = useSelector(({ musicReducer: { musics } }) => musics);
  useEffect(() => {
    getAllMusic(dispatch);
  });
  return (
    <Div>
      {/* <Title title={subTitle ? subTitle : "NEW RELEASE ALBUMS"} /> */}
      <Wrapper>
        <Container>
          {musics !== null &&
            musics.map((music, idx) => (
              <Card onClick={() => setState(idx)} key={idx} themed={theme}>
                <Image>
                  <img src={music.poster_link} alt='New release' />
                </Image>
                {stat !== idx && (
                  <Text>
                    <H2>{music.title}</H2>
                    <P>{music.artist_name}</P>
                    <P>{music.genre}</P>
                  </Text>
                )}
                {/* {stat === idx && ( */}
                <Overlay id={idx} className='overlay'>
                  <Text color='#fff'>
                    <H2>{music.title}</H2>
                    <P>{music.artist_name}</P>
                    <AudioStyle
                      controls
                      src={music.download_link}
                      type='audio/mpeg'
                    ></AudioStyle>
                  </Text>
                </Overlay>
                {/* )} */}
              </Card>
            ))}
        </Container>
      </Wrapper>
    </Div>
  );
};

export default NewRelease;

const AudioStyle = styled.audio`
  width: 250px;
`;
